import { render, staticRenderFns } from "./entityBase.vue?vue&type=template&id=1794aedc&"
import script from "./entityBase.vue?vue&type=script&lang=js&"
export * from "./entityBase.vue?vue&type=script&lang=js&"
import style0 from "./entityBase.vue?vue&type=style&index=0&id=1794aedc&prod&lang=less&"
import style1 from "./entityBase.vue?vue&type=style&index=1&id=1794aedc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports